
/// Days and weeks

// Goes back seven days from the passed in value
function getLastWeeksDate(startDate) {
    return getDateDaysAgo(startDate, 7);
}

function getDateDaysAgo(startDate, days) {
    return new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() - days));
}

function getDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

/// Gets the Date for the previous day. Day is day of week, starting with Sunday = 0
function getPreviousDay(day, date = new Date()) {
    const previousDay = new Date();

    previousDay.setDate(date.getDate() - ((date.getDay() + day) % 7));

    return previousDay;
}

function getPreviousSunday() {
    return getPreviousDay(0, new Date());
}

function addDays(baseDate, days) {
    var date = new Date(baseDate.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function getDatesFromTo(startDate, endDate) {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= endDate) {
        dateArray.push(new Date(currentDate));
        currentDate = addDays(currentDate, 1);
    }
    return dateArray;
}

/// Months

function getMonthExtents(baseDate) {
    const firstDay = new Date(Date.UTC(baseDate.getFullYear(), baseDate.getMonth(), 1));
    const lastDay = new Date(Date.UTC(baseDate.getFullYear(), baseDate.getMonth() + 1, 0)); // 0 is end of previous month

    return {
        firstDay: firstDay,
        lastDay: lastDay
    };
}

function getLastMonthExtents() {
    const now = new Date();
    const lastMonth = new Date(Date.UTC(now.getFullYear(), now.getMonth() - 1, 1));

    return getMonthExtents(lastMonth);
}

// Formatting

function toShortAuDateString(baseDate) {
    if (baseDate) {
        var dt = new Date(baseDate);
        var month = (dt.getMonth() + 1).toString().padStart(2, "0");
        return `${dt.getDate()}/${month}/${dt.getFullYear()}`;
    } else {
        return '-';
    }
}

function toYYYYMMDD(dateObj) {
    var monthStr = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    var dayStr = dateObj.getDate().toString().padStart(2, '0');
    return `${dateObj.getFullYear()}-${monthStr}-${dayStr}`;
}

function toDateString(dateObj) {
    var str = toYYYYMMDD(dateObj);
    return str;
}


/// Return the date as a sentence. eg. 3rd March 2023
function toDateSentence(dateObj) {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    let dayNumber = dateObj.getDate();
    let month = monthNames[dateObj.getMonth()];
    let year = dateObj.getFullYear();

    let daySuffix = "th";
    if (dayNumber === 1) {
        daySuffix = "st";
    } else if (dayNumber === 2) {
        daySuffix = "nd";
    } else if (dayNumber == 3) {
        daySuffix == "rd";
    }

    return `${dayNumber}${daySuffix} ${month} ${year}`;
}

// Date Range

function calcDatesForDateRange(dateRange, curStart, curEnd) {
    let startDate = (curStart && !isNaN(curStart)) ? toDateString(curStart) : null;
    let endDate = (curEnd && !isNaN(curEnd)) ? toDateString(curEnd) : null;
    switch (dateRange) {
        case 0: // SetDateRange
            break;
        case 1: // FromDateToNow
            endDate = toDateString(new Date());
            break;
        case 2: // LastWeek
            {
                let lendDate = getPreviousSunday();
                let lstartDate = getDateDaysAgo(lendDate, 6); // want sunday - 6, to give us the week
                startDate = toDateString(lstartDate);
                endDate = toDateString(lendDate);
            }
            break;
        case 3: // LastMonth
            {
                let dates = getLastMonthExtents();
                startDate = toDateString(dates.firstDay);
                endDate = toDateString(dates.lastDay);
            }
            break;
    }

    return { startDate, endDate };
}

function outputDateFromDataDashForNull (data)  {
    if (data) {
        let date = new Date(data);
        return date.toLocaleDateString();
    }
    else {
        return "-";
    }
}

function outputDateTimeFromDataDashForNull(data) {
    if (data) {
        let date = new Date(data);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
    else {
        return "-";
    }
}

 

export {
    getLastWeeksDate,
    getDateDaysAgo,
    getDate,
    getPreviousDay,
    getPreviousSunday,
    getMonthExtents,
    getLastMonthExtents,
    getDatesFromTo,
    toShortAuDateString,
    toYYYYMMDD,
    toDateString,
    toDateSentence,
    calcDatesForDateRange,
    outputDateFromDataDashForNull,
    outputDateTimeFromDataDashForNull
};